import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import {
  InputText,
  Form,
  Button,
  Row,
  Col,
  Divider,
  UploadFile,
  NumberInput
} from "common/elements";
import { getSetting, updateRecordById } from "services/setting";
import { Util } from "common/util";

export default function GeneralSetting(props) {
  const [submitting, setSubmitting] = React.useState(false);
  const [formData, setFormData] = React.useState({});
  const [logoName, setLogoName] = React.useState("");
  const navigate = useNavigate();
  const clientId = Util.getInstance().getClientId();

  const payrollPeriods = [];
  for (let i = 1; i <= 31; i++) {
    payrollPeriods.push({
      id: i,
      name: i.toString(),
    });
  }

  useEffect(() => {
    getSetting(clientId)
      .then((response) => {
        if (response && response.data) {
          const data = response.data.data;
          setFormData(data);
          setLogoName(data.logo);
        }
      }).catch(error => {
        if (error.response.status === 403) {
          localStorage.removeItem("ACCESS_TOKEN");
          navigate("/signin");
        }
      })
      // eslint-disable-next-line
  }, [clientId]);

  const handleSubmit = (values) => {
    values.id = clientId;
    values.logo = logoName;
    delete values.privateURL;
    
    setSubmitting(true);
    
    updateRecordById(values.id, values)
      .then(() => {
        Util.getInstance().sweetAlertMessage(t("text_success_update"), "success");
        this.fetchSetting(1);
      })
      .catch((err) => {
        if (err.response && err.response.data) {
          const { error } = err.response.data;
          Util.getInstance().sweetAlertMessage(error.message, "error");
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  }

  return Object.keys(formData).length ? (
    <div>
      <Form layout="vertical" onFinish={handleSubmit}>
        <div id="top-gerneral">
          <Row>
            <Col span={12}>
              <div className="pull-left">
                <h5>{t("text_general_datail")}</h5>
                <span className="title">
                  {t("text_update_your_company_profile_and_other_setting")}
                </span>
              </div>
            </Col>
            <Col span={12}>
              <div className="pull-right">
                <Button type="primary" htmlType="submit" loading={submitting}>
                  {t("text_save")}
                </Button>
              </div>
            </Col>
          </Row>
        </div>

        <div id="form-input" className="form-scroll">
          <Row className="margin-row">
            <Col lg={24} style={styles.itmeCenter}>
              <div style={styles.logo} id="logo_general">
                {formData.logo ? (
                  <div className="logo-image">
                    <img
                      src={Util.getInstance().getImageFromSpace(
                        logoName || formData.logo
                      )}
                      alt="profile"
                      style={styles.logoImg}
                    />
                  </div>
                ) : (
                  formData.name && (
                    <div className="border-logo">
                      <div className="logo-letter">
                        {Util.getInstance().getFristCharater(formData.name)}
                      </div>
                    </div>
                  )
                )}
                <UploadFile
                  name="logo"
                  logoPath={formData.logo}
                  formData={formData}
                  defaultFileList={props.defaultFileList}
                  setLogo={setLogoName}
                />
              </div>
            </Col>
            <Col lg={12}>
              <InputText
                placeholder={t("text_company_name")}
                name="name"
                label={t("text_company_name")}
                initialValue={formData.name}
              />
            </Col>
            <Col lg={12}>
              <InputText
                name="nameKH"
                label={t("text_company_name_khmer")}
                placeholder={t("text_company_name_khmer")}
                initialValue={formData.nameKH}
              />
            </Col>
            <InputText
              name="privateURL"
              initialValue={formData.privateURL}
              label={t("text_private_url")}
              placeholder={t("text_private_url")}
              disabled
              style={{display: "none"}}
            />
          </Row>

          <Divider type="divider" />

          <Row className="margin-row">
            <Col lg={24}>
              <span className="title-label">
                Bank Account
              </span>
            </Col>
            <Col lg={8}>
              <InputText
                label="Account Number"
                name="accountNumber"
                placeholder="Enter account number"
                initialValue={formData.accountNumber}
              />
            </Col>
            <Col lg={8}>
              <InputText
                label="Account Name"
                name="accountName"
                placeholder="Enter account name"
                initialValue={formData.accountName}
              />
            </Col>
            <Col lg={8}>
              <InputText
                label="Payroll Agreement ID"
                name="payrollAgreementId"
                placeholder="Enter payroll agreement ID"
                initialValue={formData.payrollAgreementId}
              />
            </Col>
            <Col lg={8}>
              <InputText
                label="Bank Name"
                name="bankName"
                placeholder="Enter bank name"
                initialValue={formData.bankName}
              />
            </Col>
            <Col lg={16}>
              <InputText
                label="Bank Address"
                name="bankAddress"
                placeholder="Enter bank address"
                initialValue={formData.bankAddress}
              />
            </Col>
          </Row>

          <Divider type="divider" />

          <Row className="margin-row">
            <Col lg={24}>
              <span className="title-label">
                Bank Account
              </span>
            </Col>
            <Col lg={8}>
              <NumberInput
                label="First Payroll Period"
                name="firstPayrollPeriod"
                placeholder="Enter first payroll period"
                initialValue={formData.firstPayrollPeriod}
                precision={0}
                max={31}
              />
            </Col>
          </Row>
        </div>
      </Form>
    </div>
  ) : null;
}

const styles = {
  inline: {
    width: 249,
  },
  noneLabel: {
    marginLeft: 38,
    marginTop: 40,
    width: 249,
  },
  noneLabelTime: {
    marginLeft: 18,
    marginTop: 40,
    width: 249,
  },
  logo: {
    flexDirection: "row",
  },
  logoImg: {
    width: 100,
    height: 100,
    objectFit: "cover",
    borderRadius: "50%",
  },
  itmeCenter: {
    display: "flex",
    justifyContent: "center",
  },
};
